import { FieldProps } from 'formik'
import React, { ReactElement } from 'react'

import TripDirection, { DirectionType, TripDirectionProps } from '@components/TripDirection/index'
import { withPluginSlot } from '@plugins/index'

export interface TripDirectionFieldProps extends FieldProps<DirectionType> {
  twoWay: TripDirectionProps['twoWay']
  weekly: TripDirectionProps['weekly']
  isOpenReturn: TripDirectionProps['isOpenReturn']
  onChange?: TripDirectionProps['onChange']
}

const TripDirectionField = ({
  field,
  form,
  twoWay,
  weekly,
  isOpenReturn,
  onChange,
}: TripDirectionFieldProps): ReactElement => {
  return (
    <TripDirection
      layout="row"
      value={field.value}
      twoWay={twoWay}
      weekly={weekly}
      isOpenReturn={isOpenReturn}
      dataTags={{
        oneWay: 'trip-direction-one-way',
        return: 'trip-direction-return',
        weekly: 'trip-direction-weekly',
        openReturn: 'trip-direction-openReturn',
      }}
      onChange={value => {
        onChange?.(value)
        form.setFieldValue(field.name, value)
      }}
    />
  )
}

export default withPluginSlot(TripDirectionField, 'TripDirectionField')
